import {useInvalidateQueryCache} from '@aboutyou/data-fetcher';
import {
  CoinsService_GetCoinsHistoryHeaderLazy,
  CoinsService_GetCoinsHistoryLazy,
  CoinsService_GetMissionsHistoryLazy,
} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/coins/v1/service.grpc.lazy';
import {WalletService_GetWalletLazy} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wallet/v1/page/service.grpc.lazy';
import {useCallback} from 'react';

export const useInvalidateWallet = () => {
  const {invalidateRequests} = useInvalidateQueryCache();

  return useCallback(() => {
    invalidateRequests([
      WalletService_GetWalletLazy.method,
      CoinsService_GetCoinsHistoryHeaderLazy.method,
      CoinsService_GetCoinsHistoryLazy.method,
      CoinsService_GetMissionsHistoryLazy.method,
    ]);
  }, [invalidateRequests]);
};
